<template>
<div>
  <PageTitle :route="$route">
    <template
      slot="action-button"
    >
      <ActionButton
        icon="fa-plus"
        @click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <StatusList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import StatusList from '@/components/settings/stock-registers/status/StatusList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Status',
  components: {
    PageTitle,
    PageRowWrapper,
    StatusList,
    ActionButton
  },
  methods: {
    onClickButton () {
      this.$router.push({ name: 'addstatus' })
    }
  }
}
</script>
